import { render, staticRenderFns } from "./PhenologicalTrackingForm.vue?vue&type=template&id=ea21d3f8&lang=html&"
import script from "./PhenologicalTrackingForm.vue?vue&type=script&lang=js&"
export * from "./PhenologicalTrackingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports